/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-east-1",
  aws_cognito_identity_pool_id:
    "us-east-1:ac2bb31e-cf95-4708-b359-2eb6a7fee80c",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_3l8ntd1w9",
  aws_user_pools_web_client_id: "67chrls6pp81gcbcsdh0b0dged",
  oauth: {
    domain: "sapienslab-dev.auth.us-east-1.amazoncognito.com",
    scope: ["email", "openid", "profile"],
    redirectSignIn: "https://localhost:3000/controlpanel",
    redirectSignOut: "https://localhost:3000/controlpanel",
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: ["GOOGLE"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS",
    ],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_cognito_identity_providers: ["COGNITO", "Google"],
};

export default awsmobile;
